<template>
  <div>
    <router-view name="brandModal"></router-view>
    <v-card>
      <v-card-title>
        <template v-if="showAddItem">
            <v-btn
                color="primary"
                class="mb-2"
                :disabled="dataTable.loading"
                :to="{ name: 'CadastrarMarca' }"
            >
                <v-icon>add</v-icon> {{ $t('brands.list.addItem') }}
            </v-btn>
            <v-divider class="mx-3 hidden-md-and-down mt-0" inset vertical></v-divider>
        </template>
        <v-text-field
          v-model="search.query"
          @click:clear="clearQuery"
          @keyup.enter="loadData()"
          type="text"
          prepend-icon="search"
          :label="$t('common.search.field')"
          clear-icon="cancel"
          clearable
          hide-details
          solo
        ></v-text-field>

        <v-btn class="ml-2" color="primary" :disabled="!search.ready" @click="loadData()">{{ $t('common.search.button') }}</v-btn>
        <v-spacer></v-spacer>
        <template v-if="showFilter">
            <v-col cols="12" md="4">
                <input-auto-complete :setup.sync="selects.client"></input-auto-complete>
            </v-col>
            <v-divider
                class="mx-3 hidden-md-and-down mt-0"
                inset
                vertical
            ></v-divider>
            <v-btn
                :loading="loading"
                :disabled="loading"
                class="ml-1"
                color="purple"
                :dark="!loading"
                @click.prevent="loadData()"
            >
                {{ $t('common.update') }}
            </v-btn>
        </template>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="pa-0">
        <data-table :setup.sync="dataTable" @delete-item="deleteItem"></data-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import API from '@/api'
import InputAutoComplete from '@/components/InputAutoComplete'
import DataTable from '@/components/DataTable'

export default {
    name: 'list-brands',
    metaInfo () {
        return {
            title: this.$t('brands.list.meta.title'),
            meta: [
                { name: 'description', content: this.$t('brands.list.meta.description') },
                { name: 'keywords', content: this.$t('brands.list.meta.keywords') }
            ]
        }
    },
    components: {
        InputAutoComplete,
        DataTable
    },
    data () {
        return {
            showFilter: false,
            loading: true,
            isAdmin: false,
            showAddItem: true,
            filters: {
                ready: false,
                fromDate: undefined,
                toDate: undefined,
                client: [],
                responsible: [],
                createdBy: [],
                status: []
            },
            search: {
                ready: true,
                query: ''
            },
            selects: {
                client: {
                    label: this.$t('common.filter.byCompany'),
                    text: 'name',
                    value: 'objectId',
                    icon: 'contacts',
                    multiple: true,
                    clearable: true,
                    hideDetails: true,
                    items: [],
                    selectedItems: []
                }
            },
            dataTable: {
                loading: true,
                itemName: this.$t('brands.list.dataTable.itemName'),
                headers: [
                    { text: this.$t('brands.list.dataTable.headers.company'), value: 'client.name', width: '15%' },
                    {
                        text: this.$t('brands.list.dataTable.headers.process'),
                        value: 'processNumber',
                        width: '10%',
                        align: 'center'
                    },
                    { text: this.$t('brands.list.dataTable.headers.brand'), value: 'brand', width: '30%' },
                    {
                        text: this.$t('brands.list.dataTable.headers.presentation'),
                        value: 'type',
                        sortable: false,
                        width: '10%',
                        align: 'center'
                    },
                    {
                        text: this.$t('brands.list.dataTable.headers.class'),
                        value: 'class',
                        sortable: false,
                        width: '10%',
                        align: 'center'
                    },
                    {
                        text: this.$t('brands.list.dataTable.headers.situation'),
                        value: 'situation',
                        sortable: false,
                        width: '20%',
                        align: 'center'
                    },
                    {
                        text: this.$t('brands.list.dataTable.headers.actions'),
                        value: 'actions',
                        align: 'center',
                        sortable: false,
                        edit: false,
                        delete: true,
                        width: '5%'
                    }
                ],
                items: [],
                totalItems: 0,
                requesterType: 'departamentos',
                requesterId: undefined,
                requesterItemId: 'objectId',
                detailTo: 'DetalheMarca',
                editTo: 'EditarMarca',
                pagination: {
                    multiSort: true,
                    mustSort: false,
                    page: 1,
                    itemsPerPage: 500,
                    groupBy: [],
                    groupDesc: [],
                    sortBy: ['createdAt'],
                    sortDesc: [true],
                    sortFormated: [{ value: 'createdAt', descending: true }]
                },
                sortingTimeout: undefined,
                footerProps: {
                    itemsPerPageOptions: [500, 250, 100, 50, 25, 10]
                }
            }
        }
    },
    watch: {
        'dataTable.pagination.sortBy': {
            handler: function (val, oldVal) {
                if (oldVal !== val) {
                    if (this.dataTable.sortingTimeout !== undefined) clearTimeout(this.dataTable.sortingTimeout)
                    this.dataTable.sortingTimeout = setTimeout(() => {
                        this.loadData()
                    }, 1000)
                }
            },
            deep: true
        },
        'dataTable.pagination.page': {
            handler: function (val, oldVal) {
                if (oldVal !== val) {
                    this.loadData()
                }
            },
            deep: true
        },
        'dataTable.pagination.itemsPerPage': {
            handler: function (val, oldVal) {
                if (oldVal !== val) {
                    this.loadData()
                }
            },
            deep: true
        },
        '$route': {
            handler: function (val, oldVal) {
                if (oldVal !== val) {
                    this.loadData()
                }
            },
            deep: true
        }
    },
    mounted () {
        this.init()
        this.loadData()
    },
    methods: {
        async init () {
            const currentUserCompany = JSON.parse(localStorage.getItem('currentUserCompany'))
            const permissions = (currentUserCompany.client.permissions) ? currentUserCompany.client.permissions.brands : undefined

            if (currentUserCompany.client.type === 'manager') {
                await this.getAllClient()
                this.showFilter = true
            }

            if (permissions !== undefined) {
                this.showAddItem = permissions.write || false
                if (permissions.delete === false) {
                    this.dataTable.headers = this.dataTable.headers.filter((header) => {
                        return header.value !== 'actions'
                    })
                }
            }
        },
        getSortFormated (sortArray) {
            const sortFormated = sortArray.map((sortObj) => {
                return `${(sortObj.descending) ? '-' : ''}${sortObj.value}`
            })
            return sortFormated.join()
        },
        async getAllClient () {
            this.selects.client.items = await this.$helpers.getAllClient(null, false, true)
        },
        clearQuery () {
            this.search.query = ''
            this.loadData()
        },
        async loadData () {
            await this.$helpers.sleep(0)
            window.getApp.refreshBrands = false
            this.loading = true
            this.dataTable.loading = true
            this.dataTable.items = []
            this.dataTable.requesterId = this.$route.params.id
            const endpoint = API.EndPoints.getCorporateBrands
            let where = {}
            if (this.selects.client.selectedItems.length > 0) {
                where = {
                    client: {
                        '$in': this.selects.client.selectedItems.map((client) => {
                            return {
                                __type: 'Pointer',
                                className: 'Client',
                                objectId: client
                            }
                        })
                    }
                }
            }

            if (this.search.query) {
                where['$or'] = [
                    { brand: { $regex: `${this.search.query}`, $options: 'i' } },
                    { processNumber: { $regex: `${this.search.query}`, $options: 'i' } }
                ]
            }

            const params = {
                limit: this.dataTable.pagination.itemsPerPage,
                skip: (this.dataTable.pagination.page - 1) * this.dataTable.pagination.itemsPerPage,
                count: true,
                order: this.getSortFormated(this.dataTable.pagination.sortFormated),
                where: JSON.stringify(where),
                include: ['client.name'],
                excludeKeys: 'ACL,image,body'
            }

            new API(endpoint, params).request().then(response => {
                this.dataTable.items = response.body.results
                this.dataTable.totalItems = response.body.count
                this.loading = false
                this.dataTable.loading = false
            }, (e) => {
                this.$helpers.requestError(e)
            })
        },
        async deleteItem (item) {
            let endpoint = API.EndPoints.deleteCorporateBrand
            endpoint.id = item.objectId
            let msg = ''
            await new API(endpoint).request()
                .then(
                    () => { msg = this.$t('brands.list.deleteMsg') },
                    (error) => { msg = (error.status !== 0) ? error.data.error : '' }
                )
            if (msg !== '') alert(msg)
            this.loadData()
        }
    }
}
</script>
